// page-meeting-indicators.ts — Rendu de l'onglet « Indicateurs » d'une réunion.
//
// Extrait de page-meeting.ts (campagne strangler, août 2026) : rendu pur, sans
// état ni accès réseau. Le chargement des données et la gouvernance par
// permission (`meeting_indicators.read`) restent dans page-meeting.ts.
//
// `esc` et `t` sont des globales (cf. types/core-globals.d.ts).

export interface MpStatIndicator {
  updated: number;
  pct: number;
  reference_date?: string;
  reference_at?: string;
}

export interface MpActionStats {
  scope_total: number;
  since_last_instance: MpStatIndicator | null;
  since_last_alert: MpStatIndicator | null;
}

function fmtDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
}

function renderIndicatorBlock(
  label: string,
  ind: MpStatIndicator | null,
  total: number,
  hint: string,
  emptyMsg: string,
): string {
  const box =
    'flex:1 1 240px;border:1px solid var(--border);border-radius:8px;padding:14px 16px;background:var(--bg2)';
  if (!ind) {
    return `<div style="${box}">
        <div style="font-size:13px;font-weight:600;color:var(--text);margin-bottom:6px">${esc(label)}</div>
        <div style="font-size:13px;color:var(--text3)">${esc(emptyMsg)}</div>
      </div>`;
  }
  return `<div style="${box}">
      <div style="font-size:13px;font-weight:600;color:var(--text);margin-bottom:6px">${esc(label)}</div>
      <div style="font-size:24px;font-weight:700;color:var(--accent)">${ind.updated}<span style="font-size:14px;font-weight:500;color:var(--text2)"> / ${total}</span> <span style="font-size:16px;font-weight:600;color:var(--text2)">(${ind.pct}%)</span></div>
      <div style="font-size:12px;color:var(--text3);margin-top:6px">${esc(hint)}</div>
    </div>`;
}

export function renderIndicatorsContent(s: MpActionStats): string {
  if (s.scope_total === 0) {
    return `<div class="empty-state" style="padding:24px;text-align:center;color:var(--text3)">${esc(t('pageMeeting.indicators.emptyScope'))}</div>`;
  }
  const instRef = s.since_last_instance?.reference_date;
  const alertRef = s.since_last_alert?.reference_at;
  const instHint = instRef
    ? t('pageMeeting.indicators.refDate').replace('{date}', fmtDate(instRef))
    : '';
  const alertHint = alertRef
    ? t('pageMeeting.indicators.refDate').replace('{date}', fmtDate(alertRef.slice(0, 10)))
    : '';
  return `
      <p style="margin:0 0 12px 0;font-size:13px;color:var(--text2)">${esc(
        t('pageMeeting.indicators.scope').replace('{n}', String(s.scope_total)),
      )}</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap">
        ${renderIndicatorBlock(t('pageMeeting.indicators.sinceInstance'), s.since_last_instance, s.scope_total, instHint, t('pageMeeting.indicators.noInstance'))}
        ${renderIndicatorBlock(t('pageMeeting.indicators.sinceAlert'), s.since_last_alert, s.scope_total, alertHint, t('pageMeeting.indicators.noAlert'))}
      </div>`;
}
